import React, { useState } from "react";
import { Form, Input, Button, Typography, Card, message, Divider } from "antd";
import LockOutlined from "@ant-design/icons/LockOutlined";
import UserOutlined from "@ant-design/icons/UserOutlined";
import { useAPI } from "../lib/hook/APIProvider";
import { useNavigate, useNavigation } from "react-router-dom";
import { useAuth } from "../lib/hook/AuthProvider";
const { Title } = Typography;

const LoginPage: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const onFinish = async (values: { identity: string; password: string }) => {
    setLoading(true);
    try {
      await login(values.identity, values.password);
      message.success("로그인 성공!");
      navigate("/");
    } catch (err: any) {
      message.error("로그인 실패: 아이디 또는 비밀번호를 확인해주세요.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f0f2f5",
      }}
    >
      <Card
        style={{ width: 400, padding: "20px", borderRadius: "12px" }}
        bordered={false}
      >
        <Title level={3} style={{ textAlign: "center", marginBottom: "30px" }}>
          로그인
        </Title>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 24,
          }}
        >
          <UserOutlined style={{ fontSize: 48, color: "#1890ff" }} />
        </div>
        <Form name="login" onFinish={onFinish} layout="vertical">
          <Form.Item
            name="identity"
            rules={[{ required: true, message: "아이디를 입력해주세요." }]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="아이디"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: "비밀번호를 입력해주세요." }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="비밀번호"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button
              className="bg-blue-500 hover:bg-blue-300 active:bg-blue-600 transition-colors w-full h-10 text-base"
              type="primary"
              htmlType="submit"
              block
              size="large"
              loading={loading}
            >
              로그인
            </Button>
            <Divider></Divider>
            <Typography.Text>
              아이디 추가는 경영팀에 문의해주세요
            </Typography.Text>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default LoginPage;
